export const day = new Date().getDate();
export const month = new Date().getMonth() + 1;
export const year = new Date().getFullYear();
export const thisDate = `${month}/${day}/${year}`;
